import { useState, useEffect } from 'react'
import { Skill } from 'types/common'
import { AiSkillsProps } from './skills'

/**
 * Hook para controlar intentos limitados
 * @param processId - ID único del proceso
 * @param maxAttempts - Número máximo de intentos permitidos (por defecto: 2)
 */
export const useLimitedAttempts = (processId: string, maxAttempts = 2) => {
  const storageKey = `attempts-${processId}`
  const [attempts, setAttempts] = useState<number>(0)
  const [hasReachedLimit, setHasReachedLimit] = useState<boolean>(false)

  useEffect(() => {
    const storedAttempts = localStorage.getItem(storageKey)
    const currentAttempts = storedAttempts ? parseInt(storedAttempts, 10) : 0
    setAttempts(currentAttempts)
    setHasReachedLimit(currentAttempts >= maxAttempts)
  }, [storageKey, maxAttempts])

  const registerAttempt = () => {
    if (attempts >= maxAttempts) {
      return false
    }

    const newAttempts = attempts + 1
    localStorage.setItem(storageKey, newAttempts.toString())
    setAttempts(newAttempts)

    const reachedLimit = newAttempts >= maxAttempts
    setHasReachedLimit(reachedLimit)

    return !reachedLimit
  }

  return {
    attempts,
    hasReachedLimit,
    registerAttempt,
  }
}

export const useAvailableSkills = (skills: Skill[], aiSkills: AiSkillsProps[]) => {
  const [availableSkills, setAvailableSkills] = useState<Skill[]>([])

  useEffect(() => {
    const existingIds = aiSkills.map((item) => Number(item.skill_id))
    const filteredSkills = skills.filter((skill) => !existingIds.includes(skill.id))
    setAvailableSkills(filteredSkills)
  }, [skills, aiSkills])

  return { availableSkills }
}

export const loadingMessages = [
  'Procesando la información que nos proporcionaste...',
  'Analizando las mejores recomendaciones para ti...',
  'Adaptando el perfil a tu industria y contexto...',
  'Ajustando niveles de experiencia requeridos...',
  'Preparando la prueba 3D Skills, casi listo...',
]

export const AI_SKILLS_HEADERS = [
  {
    key: 'skill',
    name: 'Nombre',
  },
]

export const MOCK_SKILLS = [
  {
    skill_id: 2,
    skill_name: 'Resolución de Problemas',
    description: '2Es la habilidad para identificar la causa raíz de…nta una cultura de aprendizaje y mejora continua.',
    language: 'ES',
    ideal_profile: 2,
  },

  {
    skill_id: 3,
    skill_name: 'Flexibilidad ',
    description: 'Es la habilidad de adaptarse a entornos ambiguos y…uevas ideas, prácticas, metodologías y procesos. ',
    language: 'ES',
    ideal_profile: 2,
  },

  {
    skill_id: 4,
    skill_name: 'Innovación',
    description: 'Es la capacidad de estar al tanto de las novedades…ene una perspectiva holística de la organización.',
    language: 'ES',
    ideal_profile: 2,
  },

  {
    skill_id: 5,
    skill_name: 'Pensamiento Crítico',
    description: 'Es la habilidad para cuestionar lo establecido, id…uando no fomenta los resultados o la efectividad.',
    language: 'ES',
    ideal_profile: 2,
  },

  {
    skill_id: 6,
    skill_name: 'Aprendizaje Rápido',
    description: 'Preguntas en escala Likert de 1 a 5, única respuesta.',
    language: 'ES',
    ideal_profile: 2,
  },
]
